export const qualifications = [
  {
    year : '2021-26',
    educationLevel : '(BTech+MTech) Dual Degree Course in Electronics and Electrical Communication',
    schoolName : 'IIT Kharagpur'
  },
  {
    year: "2019 - 2021",
    educationLevel: "Higher Secondary Education",
    schoolName: "Sri Sankara Vidyalaya, Bhilai",
  },
  {
    year: "2007 - 2019",
    educationLevel: "Secondary Education",
    schoolName: "Mona Modern Eng. Med. School Sarangarh",
  },
];